<template>
    <div id="default-view"><slot /></div>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>

<style lang="scss">
// #default-view {
// display: flex;
// flex-direction: row;
// }
</style>
